import React, { Component } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Autocomplete, Box, Button, TextField, Typography, Tooltip, IconButton } from '@mui/material'
import CommonGridHeader, { CommonPatientCard, CommonPatientDetails } from '../../../../Components/Common Components/CommonComponents'
import { Colors } from '../../../../Styles/Colors'
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import Loader from '../../../../Components/Loader';
import { DataGrid } from '@mui/x-data-grid'
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { Bucket_Name } from '../../../../Utility/Constants'
import PrintPreviewPop from '../../../../Components/Common Components/PrintPreviewPop'
import {fetchAndConvertToBase64} from '../../../../Components/CommonFunctions/CommonFunctions'

const Order_Type = [
  { label: 'All', value: 'All' },
  { label: 'Prescription', value: 'Prescription' },
  { label: 'Lab Test', value: 'Labtest' },
  { label: 'Radiology Test', value: 'Radiologytest' },
  { label: 'Investigation', value: 'Investigation' },
  { label: 'Glass Prescription', value: 'Glass Prescription' },
]

let AWS = require('aws-sdk');
let s3 = new AWS.S3({
  signatureVersion: 'v4',
  region: "ap-south-1",
  params: { Bucket: Bucket_Name },
});

export default class DocPrintOrder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      patientDetails: {},
      clinicId: '',
      patientId: '',
      appointmentId: '',
      printOrderData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      startDate: '',
      endDate: '',
      dateIndex: 0,
      orderTypeList: Order_Type,
      selectedOrderType: Order_Type[0]
    }
  }

  componentDidMount() {
    let clinicId = getCachevalue('SelectedDoctorClinic')
    let appointmentId = this.props.fromOT ? JSON.parse(getCachevalue("OTpatientData")) : this.props.fromIP ? JSON.parse(getCachevalue('IppatientData')) : JSON.parse(getCachevalue('DoctorPatientData'))
    let UserData = JSON.parse(localGetItem('loggedInUserInfo'))
    this.setState({
      clinicId:this.props.history?.location?.state?.fromView ? UserData?.clinic_id : clinicId,
      appointmentId: appointmentId?.appointment_id ? appointmentId?.appointment_id : this.props.history?.location?.state?.patientDetails?.appointment_id,
      patientId: appointmentId?.patient_id ? appointmentId?.patient_id : this.props.history?.location?.state?.patientDetails?.patient_id,
      admissionId: appointmentId?.id ? appointmentId?.id : null,
      patientDetails: appointmentId,
    }, () => {
      this.getPatientDetailData()
      this.getPrintOrderReportData()
    })
  }

  getPatientDetailData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientDetails: {...this.state.patientDetails, ...response?.data?.data}
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getPrintOrderReportData = () => {
    try {
      this.setState({ loading: true })
      let Query = `?patient_id=${this.state.patientId}&clinic_id=${this.state.clinicId}&from_date=${this.state.startDate}&to_date=${this.state.endDate}&test=${this.state.selectedOrderType?.value}`
      if(this.props.fromIP){
        Query = Query + `&ip_admission_id=${this.state.admissionId ? this.state.admissionId : null}`
      }
      RestAPIService.getAll(Serviceurls.DOC_PRINT_ORDER_REPORT + Query)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              printOrderData: response.data.data,
              loading: false
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ loading: false })
      this.errorMessage(error.message)
    }
  }

  printOrderDataPrint = (item) => {
    let loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const isUmaNote = loginInfo?.new_doctor_notes_template;
    const isOpt = loginInfo?.service_type === "OPT" || loginInfo?.service_type === "OPTOMETRY";
    try {
      let params = ""
      if (item?.order === "Prescription") {
        item?.service_type ? 
        params = Serviceurls.OPT_PRESCRIPTION_PRINT + `?prescription_id=${item?.prescription_id}&clinic_id=${this.state.clinicId}&language=${"english"}&appointment_id=${item?.appointment_id}`
        :
        params = Serviceurls.PRINT_PRESCRIPTION + `?prescription_id=${item?.prescription_id}&clinic_id=${this.state.clinicId}&language=${"english"}&appointment_id=${item?.appointment_id}`
      } else if (item?.order === "Radiologytest") {
        params = (localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_RAD_RESULT_PRINT : Serviceurls.RAD_RESULT_PRINT) + `?id=${item?.id ? item?.id : null}&radiology_id=${item?.radiology_id ? item?.radiology_id : null}&export_type=pdf`
      } else if (isUmaNote && isOpt && item?.order === "Glass Prescription"){
        params = Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION + `?patient_id=${this.state.patientId}&clinic_id=${this.state.clinicId}&appointment_id=${item?.appointment_id}&doctor_id=${item?.doctor_id}&export_type=pdf`
      } else {
        params = Serviceurls.DOC_PRINT_ORDER_REPORT + `?patient_id=${this.state.patientId}&clinic_id=${this.state.clinicId}&appointment_id=${item?.appointment_id}&from_date=${this.state.startDate}&to_date=${this.state.endDate}&test=${item?.order}&export_type=pdf`
      }
      RestAPIService.getAllTwo(params)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  async getS3Key(documents) {
    try {
      if (!documents || documents.length === 0) return;

      let previewItems = [];

      for (const doc of documents) {
        const docName = doc.document_name;
        const docKey = doc.document_file;

        const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(docKey));

        if (response.data.status === "success") {
          const fileUrl = response?.data?.data;
          console.log("fileUrl", fileUrl)
          if (docName.toLowerCase().includes("jpg")) {
            // Fetch image and convert to blob object URL
            const fileResponse = await fetch(fileUrl);
            const blob = await fileResponse.blob();
            const imageUrl = URL.createObjectURL(blob);
            previewItems.push({ type: "image", url: imageUrl, name: docName });
          } else {
            // PDF or other formats
            const base64 = await fetchAndConvertToBase64(fileUrl);

            const pdfBase64 = base64.replace(
              "data:binary/octet-stream;",
              "data:application/pdf;"
            );

            previewItems.push({ type: "pdf", url: pdfBase64, name: docName });
          }
        }
      }

      this.setState({
        printPreviewPop: true,
        printPreviewData: previewItems,
        pdfName: "Result Preview"
      });

    } catch (e) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: "Error fetching S3 URL"
      });
    }
  }

  closePrintPreview = () => {
    this.setState({
      printPreviewPop: false,
      printPreviewData: '',
      pdfName: ''
    })
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  filterDate = (From, To, Index) => {
    this.setState({
      startDate: From,
      endDate: To,
      dateIndex: Index
    })
  }

  onClearPrintOrder = () => {
    try {
      this.setState({
        selectedOrderType: Order_Type[0],
        startDate: '',
        endDate: '',
        dateIndex: 0
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderLeftSide = () => {
    try {
      this.state.printOrderData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        { field: 'appointment_date', headerName: `${this.props.fromIP ? "Date & Time" : "Appointment Date & Time"}`, flex: 0.25 },
        { field: 'doctor_name', headerName: 'Doctor Name', flex: 0.25 },
        { field: 'order', headerName: 'Order Type', flex: 0.25 },
        {
          field: 'action', headerName: 'Action', flex: 0.25,
          renderCell: ({ row }) => (
            <Box emed_tid={`doc_print_order_action_cell_${row.sno}`}>
              <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                onClick={() => this.printOrderDataPrint(row)}
                emed_tid={`doc_print_order_print_btn_${row.sno}`}
              >Print</Button>
              {(row?.order === "Radiologytest" && row?.result_document?.length > 0) ?
                <Tooltip placement="top" title={"View Document"} arrow emed_tid={`doc_print_order_view_tooltip_${row.sno}`}>
                  <IconButton onClick={() => { this.getS3Key(row?.result_document) }} emed_tid={`doc_print_order_view_btn_${row.sno}`}>
                    <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'1.5vw'} width={'1.5vw'} emed_tid={`doc_print_order_view_icon_${row.sno}`} />
                  </IconButton>
                </Tooltip>
                : null}
            </Box>), disableExport: true
        },
      ]
      return (
        <DataGrid
          rows={this.state.printOrderData}
          columns={columns}
          getRowId={(row) => row['sno']}
          page={this.state.page}
          pageSize={this.state.pageSize}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          sx={{ backgroundColor: Colors.white }}
          components={{
            Toolbar: CommonGridHeader.CommonToolBar,
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata' emed_tid="doc_print_order_no_records">
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          onPageChange={(newPage) => { this.setState({ page: newPage }) }}
          onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          headerHeight={40}
          disableSelectionOnClick
          loading={this.state.loading}
          emed_tid="doc_print_order_datagrid"
        />
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderRightSide = () => {
    try {
      return (
        <Box emed_tid="doc_print_order_filter_container">
          <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'} emed_tid="doc_print_order_filter_title">
            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText} emed_tid="doc_print_order_filter_title_text">Print Order Reports</Typography>
          </Box>
          <Box component={'div'} height={'49vh'} sx={{ background: Colors.white }} p={'1vw'} emed_tid="doc_print_order_filter_content">
            <Box component={'div'} width={'21vw'} emed_tid="doc_print_order_date_picker_container">
              <CommonDatePicker
                FromDate={this.state.startDate}
                ToDate={this.state.endDate}
                DateIndex={this.state.dateIndex}
                SelectedDates={this.filterDate.bind(this)}
                emed_tid="doc_print_order_date_picker"
              // HideAllMenu={true}
              />
            </Box>
            <Box mt={'1vw'} emed_tid="doc_print_order_type_container">
              <Autocomplete
                clearIcon
                size='small'
                sx={{ width: '20vw' }}
                autoComplete='off'
                defaultValue={'All'}
                options={this.state.orderTypeList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                value={this.state.selectedOrderType}
                onChange={(event, newValue) => this.setState({ selectedOrderType: newValue })}
                renderInput={(params) => <TextField {...params} label='Select Order Type' emed_tid="doc_print_order_type_input" />}
                emed_tid="doc_print_order_type_autocomplete"
              />
            </Box>
          </Box>
          <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'} emed_tid="doc_print_order_filter_buttons">
            <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
              variant='outlined'
              onClick={() => this.onClearPrintOrder()}
              emed_tid="doc_print_order_clear_btn"
            >Clear</Button>
            <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
              variant='contained'
              onClick={() => this.getPrintOrderReportData()}
              emed_tid="doc_print_order_search_btn"
            >Search</Button>
          </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  render() {
    let attender = {
      lineOne: "Attender Name",
      lineTwo: `${this.state.patientDetails?.attender_name ? this.state.patientDetails?.attender_name :
        this.state.patientDetails?.caretaker_name ? this.state.patientDetails?.caretaker_name : "-"}`,
      lineFour: 'Contact Number',
      LineFive: `${this.state.patientDetails?.attender_mobile ? this.state.patientDetails?.attender_mobile :
        this.state.patientDetails?.caretaker_mobile ? this.state.patientDetails?.caretaker_mobile : "-"}`
    }
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'} emed_tid="doc_print_order_container">
        <Box component={'div'} display={'flex'} emed_tid="doc_print_order_header">
          <Box component={'div'} className='doc_header_card' mr={'0.5vw'} emed_tid="doc_print_order_patient_card">
            <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={this.props.fromIP ? false : true} emed_tid="doc_print_order_patient_details" />
          </Box>
          {/* <CommonPatientCard details={attender} showDetailed={true} /> */}
        </Box>
        <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'61.5vh'} emed_tid="doc_print_order_content">
          <Box component={'div'} flex={0.65} overflow={'scroll'} emed_tid="doc_print_order_left_side">
            {this.renderLeftSide()}
          </Box>
          <Box component={'div'} flex={0.35} border={'1px solid lightgray'} emed_tid="doc_print_order_right_side">
            {this.renderRightSide()}
          </Box>
        </Box>
        {this.state.printPreviewPop ?
          <PrintPreviewPop
            Data={this.state.printPreviewData}
            Title={this.state.pdfName}
            BillData={this.state.selectedRow}
            ClosePopUp={() => { this.closePrintPreview() }}
            history={this.props.history}
            emed_tid="doc_print_order_print_preview"
          /> : null}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="doc_print_order_error_toast"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="doc_print_order_success_toast"
          />
          : null}
        <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}
